import React from 'react';

const UnreadBadge = ({ count = 0, size = 22, background = '#2563eb', color = '#ffffff' }) => {
  const style = {
  minWidth: `${size}px`,
  height: `${size}px`,
  background: background,
  color: color,
  fontSize: size <= 16 ? '10px' : size <= 20 ? '11px' : '12px',
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontWeight: 700,
  flexShrink: 0,
  padding: '0 2px',
  lineHeight: 1,
  border: '2px solid white',
};

  const display = count > 99 ? '99+' : String(count);

  return (
    <span style={style} aria-label={`${display} unread`} role="status">
      {display}
    </span>
  );
};

export default UnreadBadge;
